<template>
  <section class="layout-single-card">
    <div class="columns is-centered is-vcentered is-mobile">
      <div class="column is-12-mobile is-8-tablet is-two-fifths-desktop">
        <div class="card has-adaptivepadding transition">
          <div class="card-content">
            <div class="content">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.layout-single-card {
  .columns {
    min-height: 100vh;
  }
  .icon {
    width: 10rem;
    height: 10rem;
  }
}

.has-adaptivepadding {
  padding: clamp(0.5rem, 3vw, 3rem);
}

.messages-container {
  position: relative;
  z-index: 1;
  margin-bottom: 1rem;
}
</style>
